module.exports = __webpack_public_path__ + "static/img/xls01.e3191a7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/xls01.png
// module id = z2Ij
// module chunks = 1